import { IResult } from '../types/IResponse';
import { IServerSettingsUnauthenticated } from '../../../settings/types/IServerSettingsUnauthenticated';
import { Request } from './Request';

export interface IGetServerSettingsUnauthenticatedParams {
}

export interface IGetServerSettingsUnauthenticatedResult extends IResult, IServerSettingsUnauthenticated {
}

export class GetServerSettingsUnauthenticatedRequest
    extends Request<IGetServerSettingsUnauthenticatedParams, IGetServerSettingsUnauthenticatedResult> {
  constructor(params: IGetServerSettingsUnauthenticatedParams = {}) {
    super('getServerSettingsUnauthenticated', params);
  }
}
